import { displayToastError, http } from 'app';

export const getProduct = async (productName: string): Promise<any> => {
  try {
    const response = await http.get(
      '/portal/products/:productName'.replace(':productName', productName)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Product');
  }
};
